<template>
  <div class="personal-info-summary">
    <div v-for="(personalDetail, index) in personalDetails" :key="index">
      <div class="title">{{ personalDetail.title }}</div>
      <div class="value">{{ personalDetail.value }}</div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'PersonalInfoSummary',
  computed: {
    ...mapGetters('subscription', ['personalInfoFields']),
    ...mapState('subscription', ['personalInfo']),
    personalDetails() {
      const details = [
        { fieldName: this.personalInfoFields.firstName, title: 'שם פרטי' },
        { fieldName: this.personalInfoFields.lastName, title: 'שם משפחה' },
        { fieldName: this.personalInfoFields.phoneNumber, title: 'נייד' },
      ];
      return _.map(details, ({ fieldName, title }) => {
        return { value: this.personalInfo[fieldName].value, title };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .personal-info-summary {
    font-family: SimplerPro;
    margin-bottom: 30px;

    .title {
      padding-top: 14px;
      font-size: 14px;
      line-height: 1;
    }
    .value {
      font-size: 20px;
      font-weight: bold;
      margin: 6px 0 9px;
      line-height: 1;
    }
  }
</style>
